import { render, staticRenderFns } from "./balanceBySalesGroup.vue?vue&type=template&id=d4083f3a&scoped=true"
import script from "./balanceBySalesGroup.vue?vue&type=script&lang=js"
export * from "./balanceBySalesGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4083f3a",
  null
  
)

export default component.exports